import Sonda from '@gcloud-npm/utils.monitoring.sonda';
import getUUID from '@gcloud-npm/utils.monitoring.get-uuid';
import Request from '@gcloud-npm/utils.fetch';

const PATH1 = '/model/';
const PATH2 = '/quote?pdv=1';
const EVENT_NAME = 'TRADE_IN.DEVICE_FINDER';
const PROCESS_NAME = 'ADABYRON-API';


const getDevices = ({ id, params, context, build = false }) => {
  const idRequest = getUUID();
  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context,
    uniqueId: idRequest,
    origin: PROCESS_NAME,
  });
  // const URL_API = `${TRADE_IN_HOST}${PATH1}${id}${PATH2}`;
  // const headers2Use = calculateHeaderParams(build, FAMILY_API, context);
  const request = new Request({
    method: 'GET',
    endpoint: 'http://127.0.0.1:8089/modelResult.json',
    headers: {
      withCredentials: true,
    },
    sonda,
  });
  return request.makeRequest();
};

export default getDevices;